define(function(require) {

    return [
      {
          LAYER_ID : "Unite_2008_1",
          LAYER_TYPE : "POLYGON",
          LAYER_PROPERTIES : {
              FEATURE_ID_DATACOLUMN : "CODE_UNITE",
          },
          ZOOM_LAYERING : {
              BASE_LAYER_ID : "GEO09E45_UNI_PEUP_2008",
              QUERY_EXPRESSION :{
                  LOGICAL_OPERATOR : null,
                  QUERIES : [{FIELD : "CODE_UNITE", OPERATOR : "=", VALUE : undefined}]
              },
              SWITCH_SCALE : 200000,
              REGROUP_REQUESTS : true
          }
      },
      {
          LAYER_ID : "Unite_2018",
          LAYER_TYPE : "POLYGON",
          LAYER_PROPERTIES : {
              FEATURE_ID_DATACOLUMN : "CD_UNIT_18",
          },
          ZOOM_LAYERING : {
              BASE_LAYER_ID : "GEO09E46_UNI_PEUP_2018",
              QUERY_EXPRESSION :{
              LOGICAL_OPERATOR : null,
                  QUERIES : [{FIELD : "CD_UNIT_2018", OPERATOR : "=", VALUE : undefined}]
              },
              SWITCH_SCALE : 200000,
              REGROUP_REQUESTS : true
          }
      },
      {
          LAYER_ID : "Unite_2023",
          LAYER_TYPE : "POLYGON",
          LAYER_PROPERTIES : {
              FEATURE_ID_DATACOLUMN : "CD_UNIT_23",
          },
          ZOOM_LAYERING : {
              BASE_LAYER_ID : "GEO09E47_UNI_PEUP_2023",
              QUERY_EXPRESSION :{
              LOGICAL_OPERATOR : null,
                  QUERIES : [{FIELD : "CD_UNIT_2023", OPERATOR : "=", VALUE : undefined}]
              },
              SWITCH_SCALE : 200000,
              REGROUP_REQUESTS : true
          }
      },
      {
          LAYER_ID : "Cs_Franco_2",
          LAYER_TYPE : "POLYGON",
          LAYER_PROPERTIES : {
              FEATURE_ID_DATACOLUMN : "CD_CS_FRA",
          },
          ZOOM_LAYERING : {
              BASE_LAYER_ID : "GEO09E01_CS_FRA",
              QUERY_EXPRESSION : {
                  LOGICAL_OPERATOR : null,
                  QUERIES : [{FIELD : "CD_CS_FRA", OPERATOR : "=", VALUE : undefined}]
              },
              SWITCH_SCALE : 200000,
              REGROUP_REQUESTS : false
          }
      },
      {
          LAYER_ID : "Cs_Anglo_2",
          LAYER_TYPE : "POLYGON",
          LAYER_PROPERTIES : {
              FEATURE_ID_DATACOLUMN : "CD_CS_ANG",
          },
          ZOOM_LAYERING : {
              BASE_LAYER_ID : "GEO09E02_CS_ANG",
              QUERY_EXPRESSION :{
                  LOGICAL_OPERATOR : null,
                  QUERIES : [{FIELD : "CD_CS_ANG", OPERATOR : "=", VALUE : undefined}]
              },
              SWITCH_SCALE : 200000,
              REGROUP_REQUESTS : false
          }
      },
      {
          LAYER_ID : "Cs_Statut_2",
          LAYER_TYPE : "POLYGON",
          LAYER_PROPERTIES : {
              FEATURE_ID_DATACOLUMN : "CODE_UNITE",
          },
          ZOOM_LAYERING : {
              BASE_LAYER_ID : "CD_CS_STA",
              QUERY_EXPRESSION :{
                  LOGICAL_OPERATOR : null,
                  QUERIES : [{FIELD : "CD_CS_STA", OPERATOR : "=", VALUE : undefined}]
              },
              SWITCH_SCALE : 200000,
              REGROUP_REQUESTS : false
          }
      }
    ];
});
